// api/returnFilingAPI.js
import axiosInstance from './axiosConfig';

const base = (clientId, formCode, fiscalYear, quarter) =>
  `/return-filings/${clientId}/${formCode}/${fiscalYear}/${quarter}`;

const returnFilingAPI = {
  // Fetches (and auto-creates as 'open') the filing status for a period.
  get: async (clientId, formCode, fiscalYear, quarter) => {
    try {
      const response = await axiosInstance.get(base(clientId, formCode, fiscalYear, quarter));
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch filing status';
    }
  },

  // payload: { filedAt?, reference? }
  markFiled: async (clientId, formCode, fiscalYear, quarter, payload = {}) => {
    try {
      const response = await axiosInstance.post(`${base(clientId, formCode, fiscalYear, quarter)}/file`, {
        accountingClient: clientId,
        ...payload,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to mark return as filed';
    }
  },

  // payload: { reason }
  unfile: async (clientId, formCode, fiscalYear, quarter, payload) => {
    try {
      const response = await axiosInstance.post(`${base(clientId, formCode, fiscalYear, quarter)}/unfile`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to reopen return';
    }
  },

  // `total` is the exact figure the just-exported file contains — computed by
  // the caller from the same rows it wrote out, and snapshotted server-side
  // so later reconciliation compares against what was actually exported.
  markAttachmentExported: async (clientId, formCode, fiscalYear, quarter, type, total) => {
    try {
      const response = await axiosInstance.post(
        `${base(clientId, formCode, fiscalYear, quarter)}/attachments/${type}/mark-exported`,
        { total }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to record attachment export';
    }
  },

  validateAttachment: async (clientId, formCode, fiscalYear, quarter, type) => {
    try {
      const response = await axiosInstance.patch(
        `${base(clientId, formCode, fiscalYear, quarter)}/attachments/${type}/validate`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to mark attachment validated';
    }
  },
};

export default returnFilingAPI;
